import { ChangeDetectorRef, Component} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BackurlService } from 'src/common/services/backurl/backurl.service';
import { SelectService } from 'src/common/services/select/select.service';
import { SettingService } from 'src/common/services/setting/setting.service';
import { ActionService } from 'src/services/action/action.service';
import { ActionEditComponent } from '../action-edit/action-edit.component';

@Component({
  selector: 'marketing-alert',
  templateUrl: './marketing-alert.component.html',
  styleUrls: ['./marketing-alert.component.scss']
})
export class MarketingAlertComponent extends ActionEditComponent {

  constructor(
    protected _cd: ChangeDetectorRef,
    public setting: SettingService,
    public db: ActionService,
    public select: SelectService,
    protected route: ActivatedRoute,
    protected router: Router,
    public dialog: MatDialog,
    public backURL: BackurlService,
  ) {
    super(_cd, setting, db, select, route, router, dialog, backURL);
  }
  // protected _pushModuleItemData() {
  // }

}
